import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';
import { TableCell, TableRow } from '@/Domain/components/Shared/Table/Table';

export const LoadingTableRow = () => (
  <TableRow className="hover:!bg-transparent mx-auto border-b-0">
    <TableCell colSpan={4} className="text-center py-6">
      <CenterSpinner />
    </TableCell>
  </TableRow>
);
